import React, { 
  useEffect
} from 'react'
import { Outlet, 
  useNavigate
} from 'react-router-dom'
import Logo from "../assets/pubmining_logo.png";
import { AuthContainer } from './AuthLayout.styled'

const AuthLayout = () => {
  const navigate = useNavigate()
  useEffect(() => {
    if(localStorage.getItem('token') !== null) {
      navigate("/")
    }
  }, [navigate])

  return (
    <AuthContainer>
      <div style={{ cursor: "pointer", marginInline: "auto" }}>
          <img src={Logo} alt="logo" />
        </div>
        <Outlet/>
    </AuthContainer>
  )
}

export default AuthLayout